<template>
    <section class="footer"
    v-if="vocabulary"
    >
        <div class="wrapper">

            <div class="logo">
                <img
                        v-if="vocabulary.logo"
                        :src="'https://api.grunchem.eu/storage/' + vocabulary.logo" alt="logo">

                <div class="info">
                    <p
                    v-if="vocabulary.footer_description"
                    >{{vocabulary.footer_description}}</p>
                </div>

                <div class="social"
                     v-if="vocabulary"
                >
                    <span @click="open(vocabulary.instagram)"><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M7.0007 0.600098C5.26255 0.600098 5.04441 0.607698 4.36174 0.638765C3.6804 0.669965 3.21533 0.777833 2.80839 0.936101C2.38745 1.09957 2.03038 1.31824 1.67464 1.67411C1.31864 2.02985 1.09997 2.38692 0.935968 2.80772C0.7773 3.21479 0.669298 3.68 0.638631 4.36107C0.608098 5.04374 0.600098 5.26201 0.600098 7.00016C0.600098 8.73831 0.607831 8.95578 0.638765 9.63846C0.670098 10.3198 0.777966 10.7849 0.936101 11.1918C1.0997 11.6127 1.31837 11.9698 1.67424 12.3256C2.02985 12.6816 2.38692 12.9008 2.80759 13.0642C3.21479 13.2225 3.68 13.3304 4.3612 13.3616C5.04388 13.3926 5.26188 13.4002 6.9999 13.4002C8.73818 13.4002 8.95565 13.3926 9.63833 13.3616C10.3197 13.3304 10.7853 13.2225 11.1925 13.0642C11.6133 12.9008 11.9698 12.6816 12.3254 12.3256C12.6814 11.9698 12.9001 11.6127 13.0641 11.1919C13.2214 10.7849 13.3294 10.3197 13.3614 9.63859C13.3921 8.95592 13.4001 8.73831 13.4001 7.00016C13.4001 5.26201 13.3921 5.04388 13.3614 4.3612C13.3294 3.67986 13.2214 3.21479 13.0641 2.80785C12.9001 2.38692 12.6814 2.02985 12.3254 1.67411C11.9694 1.31811 11.6134 1.09944 11.1921 0.936101C10.7841 0.777833 10.3187 0.669965 9.63739 0.638765C8.95472 0.607698 8.73738 0.600098 6.9987 0.600098H7.0007ZM6.42653 1.75343C6.59693 1.75316 6.78707 1.75343 7.00067 1.75343C8.70949 1.75343 8.91202 1.75956 9.58683 1.79023C10.2108 1.81876 10.5495 1.92303 10.7751 2.01063C11.0738 2.12663 11.2867 2.2653 11.5106 2.4893C11.7346 2.7133 11.8733 2.92664 11.9895 3.22531C12.0771 3.45064 12.1815 3.78931 12.2099 4.41332C12.2406 5.08799 12.2473 5.29066 12.2473 6.99868C12.2473 8.7067 12.2406 8.90937 12.2099 9.58404C12.1814 10.208 12.0771 10.5467 11.9895 10.7721C11.8735 11.0707 11.7346 11.2834 11.5106 11.5073C11.2866 11.7313 11.0739 11.8699 10.7751 11.9859C10.5498 12.0739 10.2108 12.1779 9.58683 12.2065C8.91216 12.2371 8.70949 12.2438 7.00067 12.2438C5.29172 12.2438 5.08918 12.2371 4.41451 12.2065C3.7905 12.1777 3.45183 12.0734 3.2261 11.9858C2.92743 11.8698 2.71409 11.7311 2.49009 11.5071C2.26609 11.2831 2.12742 11.0703 2.01115 10.7715C1.92355 10.5462 1.81915 10.2075 1.79075 9.58351C1.76008 8.90883 1.75395 8.70616 1.75395 6.99708C1.75395 5.28799 1.76008 5.08639 1.79075 4.41172C1.81928 3.78771 1.92355 3.44904 2.01115 3.22344C2.12715 2.92477 2.26609 2.71143 2.49009 2.48743C2.71409 2.26343 2.92743 2.12476 3.2261 2.00849C3.4517 1.92049 3.7905 1.81649 4.41451 1.78783C5.00492 1.76116 5.23372 1.75316 6.42653 1.75182V1.75343ZM10.417 2.81611C9.99297 2.81611 9.64897 3.15971 9.64897 3.58385C9.64897 4.00785 9.99297 4.35185 10.417 4.35185C10.841 4.35185 11.185 4.00785 11.185 3.58385C11.185 3.15984 10.841 2.81611 10.417 2.81611ZM7.00071 3.71345C5.18562 3.71345 3.71401 5.18506 3.71401 7.00015C3.71401 8.81523 5.18562 10.2862 7.00071 10.2862C8.81579 10.2862 10.2869 8.81523 10.2869 7.00015C10.2869 5.18506 8.81579 3.71345 7.00071 3.71345ZM7.00068 4.86679C8.17883 4.86679 9.13404 5.82187 9.13404 7.00015C9.13404 8.17829 8.17883 9.1335 7.00068 9.1335C5.8224 9.1335 4.86733 8.17829 4.86733 7.00015C4.86733 5.82187 5.8224 4.86679 7.00068 4.86679Z" fill="white"/>
</svg>
</span>

                    <span @click="open(vocabulary.twitter)"><svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M5.6406 2.75395L5.66578 3.16917L5.2461 3.11833C3.71843 2.92343 2.38383 2.26245 1.25067 1.15236L0.696681 0.601544L0.553988 1.0083C0.251813 1.91502 0.444869 2.87258 1.0744 3.51661C1.41015 3.87252 1.33461 3.92336 0.755438 3.71151C0.553988 3.64372 0.377719 3.59287 0.360931 3.6183C0.302175 3.67761 0.503625 4.44875 0.663106 4.75381C0.881344 5.17752 1.32621 5.59274 1.81305 5.83849L2.22434 6.03339L1.73751 6.04187C1.26746 6.04187 1.25067 6.05034 1.30103 6.22829C1.46891 6.77911 2.13201 7.36381 2.87066 7.61803L3.39108 7.79599L2.93781 8.06716C2.26631 8.45696 1.4773 8.67729 0.688288 8.69424C0.310569 8.70271 0 8.7366 0 8.76203C0 8.84677 1.02404 9.32131 1.61999 9.50774C3.40786 10.0586 5.53148 9.82128 7.1263 8.88066C8.25945 8.21122 9.39261 6.88079 9.92142 5.59274C10.2068 4.90635 10.4922 3.65219 10.4922 3.05054C10.4922 2.66073 10.5174 2.60989 10.9874 2.14382C11.2644 1.87265 11.5246 1.57606 11.575 1.49132C11.6589 1.33031 11.6505 1.33031 11.2224 1.47437C10.509 1.72859 10.4083 1.69469 10.7608 1.31336C11.021 1.04219 11.3316 0.5507 11.3316 0.406642C11.3316 0.381219 11.2057 0.42359 11.063 0.499856C10.9119 0.584596 10.5761 0.711706 10.3243 0.787973L9.87105 0.932031L9.45976 0.652388C9.23313 0.499856 8.91417 0.330375 8.74629 0.279531C8.31821 0.160895 7.6635 0.177843 7.27738 0.313427C6.22816 0.694758 5.56506 1.67774 5.6406 2.75395Z" fill="white"/>
</svg>
</span>
                    <span @click="open(vocabulary.youtube)"><svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M12.0009 0.874762C12.5517 1.02589 12.9854 1.4712 13.1326 2.03671C13.4001 3.06162 13.4001 5.2001 13.4001 5.2001C13.4001 5.2001 13.4001 7.3385 13.1326 8.36349C12.9854 8.92899 12.5517 9.3743 12.0009 9.52551C11.0028 9.8001 7.0001 9.8001 7.0001 9.8001C7.0001 9.8001 2.99741 9.8001 1.99923 9.52551C1.44846 9.3743 1.01472 8.92899 0.867516 8.36349C0.600098 7.3385 0.600098 5.2001 0.600098 5.2001C0.600098 5.2001 0.600098 3.06162 0.867516 2.03671C1.01472 1.4712 1.44846 1.02589 1.99923 0.874762C2.99741 0.600098 7.0001 0.600098 7.0001 0.600098C7.0001 0.600098 11.0028 0.600098 12.0009 0.874762ZM5.80011 3.40006V7.40006L9.00011 5.40013L5.80011 3.40006Z" fill="white"/>
</svg>
</span>
                </div>
            </div>

            <div class="quickLinks">

                <p>{{vocabulary.quick_links}}</p>

                <a v-for="(link, i) in data.menu" :key="link[i]" :href="'/' + locale + link.slug">
                    {{link.title}}
                </a>


            </div>

            <div class="product">

                <p>{{vocabulary.products}}</p>

                <a v-for="(links, i) in this.link" :key="links[i]" :href="'/' + locale + data.menu[2].slug + '/' + links.slug">
                    {{links.title}}
                </a>


            </div>

            <div class="reachUs">
                <p>{{vocabulary.reach_us}}</p>
                <span>
                    <img src="/img/footer/email-icon.svg" alt="">
                    <a class="nav_link " :href="'mailto:' + vocabulary.email">{{vocabulary.email}}</a>
                </span>

                <span>
                    <img src="/img/footer/Mobile.svg" alt="">
                    <a class="nav_link " :href="'tel:' + vocabulary.phone">{{vocabulary.phone}}</a>
                </span>

                <span>
                    <img src="/img/footer/Location.svg" alt="">
                    <a class="nav_link " :href="vocabulary.location_link" rel="noreferrer"
                        target="_blank">{{vocabulary.location}}</a>
                </span>

            </div>

        </div>
        <div class="copyright">
            {{vocabulary.footer_copy}}
        </div>
    </section>

</template>

<script>
    import {
        RepositoryFactory
    } from "../../api/RepositoryFactory";
    const GetRepository = RepositoryFactory.get('data');

    export default {
        name: "footer.vue",
        data() {
            return {
                data: {},
                link: {},
                vocabulary: '',
                locale: window.localStorage.getItem('locale')
            }
        },
        methods: {
            fetch() {
                return new Promise((resolve, reject) => {
                    GetRepository.get()
                        .then(resp => {
                            this.data = resp.data.data.header_footer;
                            this.vocabulary = resp.data.data.header_footer.vocabulary;
                            this.link = resp.data.data.header_footer.products_in_footer;
                            resolve(resp);
                        })
                        .catch(err => {
                            reject(err);
                        });
                });
            },

            open(item) {
                window.open(item, '_blank');
                window.focus();
            }
        },
        async mounted() {
            await this.fetch()
        }
    }
</script>

<style scoped lang="scss">
    @import "../../assets/scss/index";

    section {
        color: $footerFontColor;
        background-color: $footerBg;

        .wrapper {
            max-width: 1500px;
            margin: 0 auto;
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            padding: 95px 125px 120px;
            height: auto;

            @media (max-width: 1200px) {
                padding: 55px 65px 60px;
            }

            @media (max-width: 1025px) {
                padding: 55px 40px 60px;
            }

            @media (max-width: 769px) {
                padding: 15px 20px;
            }

            @media (max-width: 576px) {
                flex-direction: column !important;
                align-items: center;
                margin-bottom: 20px;
            }

            & .logo {
                width: 40%;

                @media (max-width: 576px) {
                    width: 100%;
                }

                & .info {
                    margin-bottom: 20px;

                    & p {
                        @include descriptionItem
                    }
                }

                & .social {
                    display: flex;
                    align-items: center;
                    justify-content: flex-start;

                    @media (max-width: 575px) {
                        margin-bottom: 15px;
                    }

                    & span {
                        width: 30px;
                        height: 30px;
                        border-radius: 50%;
                        position: relative;
                        margin-right: 15px;
                        cursor: pointer;
                        background-color: $spanSocialFooter;
                        transition: $transitionLink;

                        &:nth-child(3) {
                            margin-right: 0;
                        }

                        &:hover {
                            transition: $transitionLink;
                            background-color: $hoverFooter;
                        }

                        & svg {
                            z-index: 1;
                            object-fit: contain;
                            margin: auto;
                            position: absolute;
                            top: 0;
                            bottom: 0;
                            right: 0;
                            left: 0;
                        }
                    }
                }
            }

            & .quickLinks {
                display: flex;
                flex-direction: column;

                @media (max-width: 576px) {
                    width: 100%;
                    align-items: center;
                    margin-bottom: 20px;
                }


                & p {
                    @include footerTitle;
                }

                & a {
                    @include footerLinks
                }
            }

            & .product {
                display: flex;
                flex-direction: column;

                @media (max-width: 576px) {
                    width: 100%;
                    align-items: center;
                    margin-bottom: 20px;
                }

                & p {
                    @include footerTitle
                }

                & a {
                    @include footerLinks
                }
            }

            & .reachUs {
                display: flex;
                flex-direction: column;

                @media (max-width: 576px) {
                    width: 100%;
                    align-items: center;
                    margin-bottom: 20px;
                }

                & span {
                    display: flex;
                    align-items: center;

                    & img {
                        object-fit: contain;
                        margin-right: 10px;
                        width: 20px;
                        height: 18px;
                    }
                }

                & p {
                    @include footerTitle
                }

                & a {
                    @include footerLinks;
                    line-height: 40px;
                }
            }
        }

        & .copyright {
            padding: 0 125px 20px;
            max-width: 1500px;
            margin: 0 auto;

            @media (max-width: 576px) {
                padding: 0 10px;
            }
        }
    }
</style>
